import Button from "@/components-legacy/buttons/button";
import TagPicker from "@/components-legacy/tagPicker";
import UserPicker from "@/components-legacy/userPicker";
import UseShopQuery from "@babackapp/private-api-client/client/use-shop";
import { WorkflowStepDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { ServerIcon, XIcon } from "lucide-react";
import { useParams } from "react-router-dom";
import { Handle, Position } from "reactflow";

export default function ActionNode(props: {
  data: {
    step: {
      id: string;
      operation: string;
      type: string;
      parameters: {
        users: string[];
        tags: string[];
        mail: { subject: string; body: string };
        additionnalNote: { name: string; value: string };
        reason: string[];
        status: string[];
        resolution: string[];
        note: string;
      };
    };
    onSelect: (step: WorkflowStepDto) => void;
    onDelete: (stepId: string) => void;
    isSelected: boolean;
    label: string;
  };
}) {
  const { shopId } = useParams<{ shopId: string }>();

  const { data: shop } = UseShopQuery(shopId);
  const t = useTranslation();
  const tags: string[] = [];
  if (!shop) {
    return <></>;
  }

  return (
    <div
      onClick={() => {
        props.data.onSelect(props.data.step as unknown as WorkflowStepDto);
      }}
    >
      <Handle type="target" position={Position.Top} id={props.data.step.id} />
      <div
        className={` bg-white space-y-2 font-normal text-sm w-80 group p-4 rounded-md hover:shadow-md transition-shadow transition-duration-100 cursor-pointer ${
          props.data.isSelected ? "ring-2 ring-purple-500" : ""
        }`}
      >
        <div className="flex text-gray-400 items-center justify-between">
          <div className="flex space-x-1  items-center">
            <ServerIcon className="w-4 h-4" />
            <div className=""> {t("workflow.module.action")}</div>
          </div>
          <div className="invisible group-hover:visible">
            <Button
              size="small"
              type="text"
              onClick={() => {
                props.data.onDelete(props.data.step.id);
              }}
              prefixIcon={XIcon}
            />
          </div>
        </div>

        {props.data.step.operation == "returnRequest:assignee:update" ? (
          <div>
            <div className="pb-2"> {t("workflow.module.userAssigned")}</div>

            <UserPicker
              readOnly={true}
              shopId={shopId || ""}
              usersPicked={props.data.step.parameters.users}
              onUpdateUser={() => {}}
            />
          </div>
        ) : props.data.step.operation == "returnRequest:tags:update" ? (
          <div className="flex space-x-2">
            <div className="text-sm">{t("workflow.module.tagTagged")}</div>
            <TagPicker
              readOnly={true}
              tags={tags}
              onUpdateTag={() => {}}
              tagsPicked={props.data.step.parameters.tags}
            />
          </div>
        ) : props.data.step.operation == "returnRequest:logistician:treat" &&
          props.data.step.type != "trigger" ? (
          <div className="text-sm">{t("workflow.module.treatLogi")} </div>
        ) : props.data.step.operation == "returnRequest:merchant:treat" &&
          props.data.step.type != "trigger" ? (
          <div className="text-sm">{t("workflow.module.treatMerch")} </div>
        ) : props.data.step.operation == "returnRequest:merchant:fakeTreat" &&
          props.data.step.type != "trigger" ? (
          <div className="text-sm">{t("workflow.module.treatFakeMerch")} </div>
        ) : props.data.step.operation == "returnRequest:tag:shopify" &&
          props.data.step.type != "trigger" ? (
          <div className="text-sm">
            {t("workflow.module.actionTag", {
              tags: props.data.step.parameters.tags,
            })}
          </div>
        ) : props.data.step.operation == "returnRequest:note:shopify" &&
          props.data.step.type != "trigger" ? (
          <div className="text-sm">
            {t("workflow.module.noteShopify", {
              note: props.data.step.parameters.note,
            })}
          </div>
        ) : props.data.step.operation == "returnRequest:shopifyreturn:close" &&
          props.data.step.type != "trigger" ? (
          <div className="text-sm">{t("workflow.module.closeReturn")}</div>
        ) : props.data.step.operation == "mail:ticket:zendesk" &&
          props.data.step.type != "trigger" ? (
          <div>
            <div className="text-sm">{t("workflow.module.ticketZendesk")}</div>
            <div className="text-sm">
              {t("workflow.module.subject")}

              {props.data.step.parameters?.mail?.subject || ""}
            </div>
            <div>
              {t("workflow.module.desc")}{" "}
              {props.data.step.parameters?.mail?.body || ""}
            </div>
          </div>
        ) : props.data.step.operation ==
            "returnRequest:additionnalDetails:shopify" &&
          props.data.step.type != "trigger" ? (
          <div>
            <div>{t("workflow.module.additionnalDetails")}</div>
            <div className="text-sm">
              {t("workflow.module.subject")}
              {props.data.step.parameters?.additionnalNote?.name
                ? props.data.step.parameters?.additionnalNote?.name
                : ""}
            </div>
            <div className="text-xs">
              {t("workflow.module.desc")}
              {props.data.step.parameters?.additionnalNote?.value
                ? props.data.step.parameters?.additionnalNote?.value
                : ""}
            </div>
          </div>
        ) : props.data.step.operation == "mail:ticket:gorgias" &&
          props.data.step.type != "trigger" ? (
          <div>
            <div>{t("workflow.module.ticketGorgias")}</div>
            <div className="text-sm">
              {t("workflow.module.subject")}
              {props.data.step.parameters?.mail?.subject || ""}
            </div>
            <div className="text-xs">
              {t("workflow.module.desc")}{" "}
              {props.data.step.parameters?.mail?.body || ""}
            </div>
          </div>
        ) : (
          props.data.step.type != "trigger" && (
            <div className="text-gray-400">{t("workflow.module.configureAction")}</div>
          )
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id={props.data.step.id}
      />
    </div>
  );
}
